<template>
  <div class="inline-flex overflow-hidden rounded-md bg-gpx_gray-900">
    <button
      v-for="value in values"
      :key="value"
      class="flex items-center py-1 pl-[3px] pr-1 first:pl-1"
      :class="[
        {
          'relative bg-gpx_gray-900': value === modelValue,
        },
      ]"
      @click="$emit('update:modelValue', value)"
    >
      <span
        class="relative rounded-[4px] px-[10px] py-[3px] text-[13px] font-medium leading-4 text-gpx_slate-400"
        :class="[
          {
            ' bg-white !text-gpx_black-400 shadow-sm': value === modelValue,
          },
          {
            'after:absolute after:right-[-5px] after:top-1/2 after:h-[10px] after:w-px after:bg-gpx_gray-700 after:-translate-y-1/2':
              value !== modelValue,
          },
        ]"
      >
        {{ value }}
      </span>
    </button>
  </div>
</template>

<script>
export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: [Number, String],
      required: true,
    },
    values: {
      type: Array,
      validator: (value) => {
        return value.length && value.every((v) => Boolean(v));
      },
    },
  },
};
</script>
